import React from 'react';
import { Marker } from '@react-google-maps/api';
import { ArcPolyline } from '@src/core/controllers';
import gohere from '@src/assets/gohere.svg';
import { PointEntity } from '@src/features/order/entities';
import { buildGoHereErrorPath } from './go-here-path';

function goHereMarkerIcon(): google.maps.Icon {
  return {
    url: gohere,
    scaledSize: new window.google.maps.Size(80, 40),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(12, 38),
  };
}

type GoHereLayerProps = {
  points: PointEntity[];
  origin: google.maps.LatLngLiteral | null;
};

export const GoHereLayer: React.FC<GoHereLayerProps> = ({ points, origin }) => {
  const errorPath = buildGoHereErrorPath(origin, points);
  if (points.length === 0 && errorPath.length < 2) return null;

  return (
    <>
      {points.map((point) => (
        <Marker key={point.id} position={point.position} icon={goHereMarkerIcon()} />
      ))}
      {errorPath.length >= 2 && <ArcPolyline.error path={errorPath} />}
    </>
  );
};
